<template>
  <WsMain>
    <v-skeleton-loader
      v-if="isLoading.breadCrumbsItems"
      type="table"
    ></v-skeleton-loader>
    <WsCRUD
      v-else
      ref="WsCRUD"
      pageMode
      isBreadCrumbsShow
      placeholder="搜尋模組UUID"
      :label="label"
      :fields="fields"
      :showExpand="false"
      :isCreatable="false"
      :modelName="modelName"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :showFields="showFields"
      :filterSelects="filterSelects"
      :customUrlParams="_customUrlParams"
      :getCustomReadUrl="$_getCustomReadUrl"
      :customBreadcrumbsItems="_customBreadcrumbsItems"
    >
      <template v-slot:customBtns="{item}">
        <WsIconBtn
          tooltip="再次開放同步"
          tooltipPosition="top"
          @click="$_onClickOpenReSync(item)"
          class="ml-1 mr-1"
        >mdi-update</WsIconBtn>
      </template>
    </WsCRUD>
    <WsAlertDialog
      ref="WsAlertDialog"
      title="確定要再次開放同步嗎？"
      :description="alertPopup.description"
      btnText="確認"
      color="primary"
      @submit="$_onOpenReSync($event)"
    />
  </WsMain>
</template>

<script>
import model from "@/models/syncApi";
import S_factory from "@/services/api/v1/factory";
import S_syncApi from "@/services/api/v1/syncApi";

export default {
  data() {
    return {
      isLoading: {
        breadCrumbsItems: true,
      },
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: [
        "module",
        "module_id",
        "module_uuid",
        "status",
        "date",
      ],
      parentData: {},
      alertPopup: {
        description: '',
      },
      isMounted: false,
      filterSelects: [
        {
          type: "select",
          modelName: "module",
          placeholder: "篩選模組",
          items: [
            {
              text: "act",
              value: "act",
            },
          ],
        },
        {
          type: "select",
          modelName: "status",
          placeholder: "篩選狀態",
          defaultValue: "failed",
          items: [
            {
              text: "success",
              value: "success",
            },
            {
              text: "failed",
              value: "failed",
            },
          ],
        },
        {
          type: "dateDuration",
          modelName: "date",
          timeField: "date",
        }
      ],
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$route.params.id;
    },
    _customUrlParams() {
      return {
        factory: this._currentFactoryId,
      }
    },
    _customBreadcrumbsItems() {
      return [
        {
          text: '工廠管理',
          to: '/factory',
          disabled: false,
        },
        {
          text: this.parentData.name,
          to: `/factory/${this._currentFactoryId}`,
          disabled: false,
        },
        {
          text: model.label,
          disabled: true,
        }
      ]
    }
  },
  async mounted() {
    this.isLoading.breadCrumbsItems = true;
    this.parentData = await this.$_getParentData(this._currentFactoryId);
    this.isLoading.breadCrumbsItems = false;
    this.isMounted = true;
  },
  methods: {
    $_getCustomReadUrl(item) {
      return `/factory/${this.$route.params.id}/sync_api/${item.id}`;
    },
    async $_getParentData(factoryId) {
      return await S_factory.show(factoryId);
    },
    $_onClickOpenReSync(item) {
      if (!this.isMounted) return;
      const {module, module_id, module_uuid} = item;
      this.alertPopup.description = `模組：${module}, 模組ID：${module_id}, 模組UUID：${module_uuid}`;
      this.$refs.WsAlertDialog.open(item);
    },
    async $_onOpenReSync($event) {
      if (!this.$refs.WsAlertDialog || !this.$refs.WsCRUD) return;
      this.$refs.WsAlertDialog.startLoading();
      await S_syncApi.openSync($event.id);
      await this.$refs.WsCRUD.$_fetchData();
      this.$refs.WsAlertDialog.close();
      this.$refs.WsAlertDialog.stopLoading();
    }
  }
};
</script>